import { z } from 'zod'

import { GlobalFieldSchema } from 'shared/api/common/schemas/globalField'
import { NotificationReasonSchema } from 'shared/api/common/schemas/notificationReason'
import { TagSchema } from 'shared/api/common/schemas/tag'
import { CustomEventSchema } from 'shared/api/common/schemas/templates/customEvent'
import { MapSchema } from 'shared/api/common/schemas/templates/map'
import { UserFieldSchema } from 'shared/api/common/schemas/userField'

export const ContentMapSchemas = {
  query: z.undefined(),
  path: z.object({
    pageId: z.string(),
  }),
  response: z.object({
    map: MapSchema,
  }),
}

export const CustomEventsSchema = {
  query: z.undefined(),
  path: z.object({
    pageId: z.string(),
  }),
  response: z.object({
    list: CustomEventSchema.array(),
  }),
}

export const OtnReasonsSchema = {
  path: z.object({
    pageId: z.string(),
  }),
  query: z.object({
    active_only: z.boolean().optional(),
  }),
  response: z.object({
    reasons: NotificationReasonSchema.array(),
  }),
}

export const UserFieldsSchema = {
  path: z.object({
    pageId: z.string(),
  }),
  query: z.object({
    active_only: z.boolean().optional(),
  }),
  response: z.object({
    fields: UserFieldSchema.array(),
  }),
}

export const GlobalFieldsSchema = {
  path: z.object({
    pageId: z.string(),
  }),
  query: z.object({
    active_only: z.boolean().optional(),
  }),
  response: z.object({
    fields: GlobalFieldSchema.array(),
  }),
}

export const PageTagsSchema = {
  path: z.object({
    pageId: z.string(),
  }),
  query: z.object({
    type: z.string().optional(),
  }),
  response: z.object({
    tags: TagSchema.array(),
  }),
}
